export const routesKysIcTetkik = [
  {
    path: "/kys-ic-tetkik/sorular",
    name: "kys-ic-tetkik-sorular",
    component: () => import("@/views/kys-ic-tetkik/SoruTanimlar.vue"),
    meta: { public: false, title: "kys_ic_tetkik.soru_tanimlari", yetki: { k: [1190402] } },
  },
  {
    path: "/kys-ic-tetkik/ic-tetkikler",
    name: "kys-ic-tetkik-listesi",
    component: () => import("@/views/kys-ic-tetkik/IcTetkikListesi.vue"),
    meta: { public: false, title: "kys_ic_tetkik.ic_tetkikler", yetki: { k: [1190412] } },
  },
  {
    path: "/kys-ic-tetkik/ic-tetkikler/ekle",
    name: "kys-ic-tetkik-ekle",
    component: () => import("@/views/kys-ic-tetkik/IcTetkikEkle.vue"),
    meta: { public: false, title: "kys_ic_tetkik.yeni_tetkik_ekle", yetki: { k: [1190413] } },
  },
  {
    path: "/kys-ic-tetkik/ic-tetkikler/duzelt/:uuid",
    name: "kys-ic-tetkik-duzelt",
    component: () => import("@/views/kys-ic-tetkik/IcTetkikEkle.vue"),
    meta: { public: false, title: "kys_ic_tetkik.tetkik_duzelt", yetki: { k: [1190414] } },
  },
  {
    path: "/kys-ic-tetkik/planlar",
    name: "kys-ic-tetkik-planlari",
    component: () => import("@/views/kys-ic-tetkik/IcTetkikPlanListesi.vue"),
    meta: { public: false, title: "kys_ic_tetkik.planlar", yetki: { k: [1190422] } },
  },
]
